export const getEmbellishmentMethodNameFromItemProductData = item => {
  const {
    embellishmentMethod,
    prod
  } = item;
  if (!embellishmentMethod || !(prod !== null && prod !== void 0 && prod.embellishmentMethods)) {
    return '';
  }
  const embellishmentMethodData = prod.embellishmentMethods.find(method => String(method._id) === String(embellishmentMethod));
  return (embellishmentMethodData === null || embellishmentMethodData === void 0 ? void 0 : embellishmentMethodData.name) || '';
};